import React, { useState } from 'react';
import { ArrowLeft, ArrowRight, Save, Check, Undo2, Redo2, Lock } from 'lucide-react';
import { useWizard } from '../../context/WizardContext';
import { useSubscription } from '../../context/SubscriptionContext';

const NavigationButtons = ({ 
  onNext, 
  onPrevious, 
  canProceed = true, 
  isLastStep = false,
  nextLabel = 'Next',
  showPrevious = true,
  showSave = true,
  showUndoRedo = true
}) => {
  const { 
    currentStep, 
    currentWizard,
    previousStep, 
    nextStep, 
    saveCurrentDesign, 
    undo, 
    redo, 
    canUndo, 
    canRedo 
  } = useWizard();
  const { triggerUpgradeModal, getWizardMaxStep } = useSubscription();
  const [saveStatus, setSaveStatus] = useState(null);

  const maxAccessibleStep = getWizardMaxStep(currentWizard);
  const nextStepLocked = currentStep + 1 > maxAccessibleStep;

  const handleNext = () => {
    if (nextStepLocked) {
      triggerUpgradeModal(`wizard${currentWizard}`);
      return;
    }
    if (onNext) {
      onNext();
    } else {
      nextStep();
    }
  };

  const handleSave = () => {
    try {
      saveCurrentDesign();
      setSaveStatus('saved');
      setTimeout(() => setSaveStatus(null), 2000);
    } catch (error) {
      setSaveStatus('error');
      setTimeout(() => setSaveStatus(null), 2000);
    }
  };

  return (
    <div className="navigation-buttons">
      {showPrevious && currentStep > 0 && (
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onPrevious || previousStep}
        >
          <ArrowLeft size={20} />
          Previous
        </button>
      )}
      
      {showUndoRedo && (
        <div className="undo-redo-buttons">
          <button
            type="button"
            className="btn btn-icon"
            onClick={undo}
            disabled={!canUndo}
            title="Undo last change"
          >
            <Undo2 size={18} />
          </button>
          <button
            type="button"
            className="btn btn-icon"
            onClick={redo}
            disabled={!canRedo}
            title="Redo last change"
          >
            <Redo2 size={18} />
          </button>
        </div>
      )}
      
      {showSave && (
        <button
          type="button"
          className={`btn-save-progress ${saveStatus === 'saved' ? 'saved' : ''}`}
          onClick={handleSave}
          title="Save your progress"
        >
          {saveStatus === 'saved' ? (
            <>
              <Check size={18} />
              Saved!
            </>
          ) : (
            <>
              <Save size={18} />
              Save Progress
            </>
          )}
        </button>
      )}
      
      <button
        type="button"
        className={`btn btn-primary ${nextStepLocked ? 'locked-btn' : ''}`}
        onClick={handleNext}
        disabled={!canProceed && !nextStepLocked}
        title={nextStepLocked ? 'Upgrade to continue' : ''}
      >
        {nextStepLocked ? (
          <>
            <Lock size={16} />
            Upgrade to Continue
          </>
        ) : (
          <>
            {nextLabel}
            {!isLastStep && <ArrowRight size={20} />}
          </>
        )}
      </button>
    </div>
  );
};

export default NavigationButtons;
